
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import lodash from "lodash";

import NumberInput from "@/components/Reusable/CustomInputs/NumberInput.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import { uiStore } from "@/store/store-accessor";
import { cropImage, CUSTOM_SIZE_KEY } from "@/lib/media/media";
import { Image, Size } from "@/types/media";

@Component({
  components: { NiceButton, NumberInput, DropdownInput }
})
export default class MediaCropper extends Vue {
  @Prop()
  value?: string;

  @Prop()
  image!: Image;

  width: number | null = null;
  height: number | null = null;

  get customSize(): Size {
    return lodash.get(this.image, `sizes.${CUSTOM_SIZE_KEY}`);
  }

  @Watch("value", { immediate: true })
  onSizeChange() {
    const isCustom = this.value === CUSTOM_SIZE_KEY;
    if (!isCustom) return;

    this.width = this.customSize?.width;
    this.height = this.customSize?.height;
  }

  setLoading(loading: boolean) {
    if (!uiStore.activeElementId) return;

    uiStore.setElementUpdatingState({
      isUpdating: loading,
      elementId: uiStore.activeElementId
    });
  }

  async crop() {
    if (!this.image) return;
    this.setLoading(true);
    const size = await cropImage(this.image, this.width, this.height);
    this.setLoading(false);
    return size;
  }

  async apply() {
    const size = await this.crop();
    this.$emit("input", size);
  }
}
